function apiBaseUrl() {
  return process.env.REACT_APP_API_BASE_URL;
}

export function companies(userId) {
  return `${apiBaseUrl()}/api/v2/users/${userId}/companies`;
}

export function company(userId, companyId) {
  return `${apiBaseUrl()}/api/v2/users/${userId}/companies/${companyId}`;
}

// dataPoints urls
export function dataPoint(type) {
  return `${apiBaseUrl()}/api/v2/data_points/${type}`;
}

// TODO: deprecate
export function apiV2UserCompaniesUrl(userId) {
  return `${apiBaseUrl()}/api/v2/users/${userId}/companies`;
}

export function companyEmailUpdate(userId, companyId) {
  return `${apiBaseUrl()}/api/v2/users/${userId}/companies/${companyId}/email_update`;
}

export function companyEmailUpdateConfirmation(userId, companyId) {
  return `${apiBaseUrl()}/api/v2/users/${userId}/companies/${companyId}/email_update_confirmation`;
}



// WEBPACK FOOTER //
// ./src/features/company/apiUrls.js